module.exports = __webpack_public_path__ + "img/banner_sample.40122b73.jpg";